module.exports = __webpack_public_path__ + "static/media/TrafficLight.6f05e90f.png";